module.exports = __webpack_public_path__ + "img/libya.1a4f5396.svg";